import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer2 from '../../Common/Drawer/Drawer2';

import './ResourceAllocationTasksDrawer.scss';

export class ResourceAllocationTasksDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {};
	}

	clickTask = (task) => {
		this.props.showTask(task.id);
	};

	render() {
		return (
			<Drawer2 isWide={false} title='Tasks' onCancelText='Close' onCancelClick={this.props.onCancel}>
				<div className='res-allocation-drawer'>
					<div className='range-name'>
						<strong>{this.props.seriesName}</strong>
					</div>
					<div className='date-range-name'>
						{this.props.dateRangeStart} - {this.props.dateRangeEnd}
					</div>
					<br />
					<ul className='list-group'>
						{this.props.tasks.map((task) => {
							return (
								<li key={task.id} className='list-group-item' onClick={() => this.clickTask(task)}>
									{task.name}
								</li>
							);
						})}
					</ul>
				</div>
			</Drawer2>
		);
	}
}

ResourceAllocationTasksDrawer.propTypes = {
	tasks: PropTypes.array.isRequired,
	seriesName: PropTypes.string.isRequired,
	dateRangeStart: PropTypes.string.isRequired,
	dateRangeEnd: PropTypes.string.isRequired,
	onCancel: PropTypes.func.isRequired,
	showTask: PropTypes.func.isRequired,
};

export default ResourceAllocationTasksDrawer;
